export default __webpack_public_path__ + "assets/images/f26364fa8defcbd7e0d5bea5bce896a8.png";